import type { SVGProps } from 'react';

const SvgKeyboardMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
    />
    <path
      d='M8 9C8 9.55228 7.55228 10 7 10C6.44772 10 6 9.55228 6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9Z'
      fill='currentColor'
    />
    <path
      d='M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z'
      fill='currentColor'
    />
    <path
      d='M11.3496 9C11.3496 9.55228 10.9019 10 10.3496 10C9.79732 10 9.34961 9.55228 9.34961 9C9.34961 8.44772 9.79732 8 10.3496 8C10.9019 8 11.3496 8.44772 11.3496 9Z'
      fill='currentColor'
    />
    <path
      d='M11.3496 12C11.3496 12.5523 10.9019 13 10.3496 13C9.79732 13 9.34961 12.5523 9.34961 12C9.34961 11.4477 9.79732 11 10.3496 11C10.9019 11 11.3496 11.4477 11.3496 12Z'
      fill='currentColor'
    />
    <path
      d='M14.6992 9C14.6992 9.55228 14.2515 10 13.6992 10C13.1469 10 12.6992 9.55228 12.6992 9C12.6992 8.44772 13.1469 8 13.6992 8C14.2515 8 14.6992 8.44772 14.6992 9Z'
      fill='currentColor'
    />
    <path
      d='M14.6992 12C14.6992 12.5523 14.2515 13 13.6992 13C13.1469 13 12.6992 12.5523 12.6992 12C12.6992 11.4477 13.1469 11 13.6992 11C14.2515 11 14.6992 11.4477 14.6992 12Z'
      fill='currentColor'
    />
    <path
      d='M18.0488 9C18.0488 9.55228 17.6011 10 17.0488 10C16.4965 10 16.0488 9.55228 16.0488 9C16.0488 8.44772 16.4965 8 17.0488 8C17.6011 8 18.0488 8.44772 18.0488 9Z'
      fill='currentColor'
    />
    <path
      d='M18.0488 12C18.0488 12.5523 17.6011 13 17.0488 13C16.4965 13 16.0488 12.5523 16.0488 12C16.0488 11.4477 16.4965 11 17.0488 11C17.6011 11 18.0488 11.4477 18.0488 12Z'
      fill='currentColor'
    />
    <path d='M8 15.5C11.9052 15.5 16 15.5 16 15.5' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
  </svg>
);
export default SvgKeyboardMd;
